import React, { useEffect, useState } from "react";
import { getContact } from 'services/api/Shop';
import { getOfflineContent, saveOfflineContent } from '../../utils/offlineContent';

import './Contact.scss';

const Contact = () => {
  const [contactInfo, setContactInfo] = useState({
    email: "",
    phone: "",
    fax: "",
    address1: "",
    address2: "",
    city: "",
    zipCode: "",
  });
  const [isOfflineFallback, setIsOfflineFallback] = useState(false);

  useEffect(() => {
    const loadContact = async () => {
      try {
        const response = await getContact();
        const nextContactInfo = {
          email: response?.content?.email || "",
          phone: response?.content?.phone || "",
          fax: response?.content?.fax || "",
          address1: response?.content?.address1 || "",
          address2: response?.content?.address2 || "",
          city: response?.content?.city || "",
          zipCode: response?.content?.zipCode || "",
        };

        if (!nextContactInfo.email && !nextContactInfo.phone && !nextContactInfo.address1) {
          throw new Error('Contact content unavailable');
        }

        setContactInfo(nextContactInfo);
        setIsOfflineFallback(false);
        saveOfflineContent('contact-page', nextContactInfo);
      } catch (_error) {
        const cachedContent = getOfflineContent('contact-page');

        if (cachedContent?.value) {
          setContactInfo(cachedContent.value);
          setIsOfflineFallback(true);
        }
      }
    };

    loadContact();
  }, []);

  const url ="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1456.025662587726!2d6.094450658292751!3d43.12444799478576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12c922595cd763e5%3A0xca005237cd5ec7d0!2sSica%20March%C3%A9%20Aux%20Fleurs%20d'Hy%C3%A8res!5e0!3m2!1sfr!2sfr!4v1584117925024!5m2!1sfr!2sfr";
  const phoneLink = contactInfo.phone
    ? `tel:+33${contactInfo.phone.substring(1).replace(/\s/g, '')}`
    : null;

  return (
    <div className="container contact">
      <h1>Contact</h1>
      {isOfflineFallback && (
        <p className="offline-content-notice">
          Vous consultez la dernière version enregistrée de cette page.
        </p>
      )}
      <div className="row">
        <div className="col-md-6">
          <div className="contact-paragraph">
            <h2>Pour nous contacter :</h2>
            <div className="row">
              <div className="col-6">Par email :</div>
              <div className="col-6">
                <a href = {`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </div>
            </div>
            <div className="row">
              <div className="col-6">Par téléphone :</div>
              <div className="col-6">
                {phoneLink ? (
                  <a href={phoneLink}>{contactInfo.phone}</a>
                ) : (
                  contactInfo.phone
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-6">Par Fax :</div>
              <div className="col-6">{contactInfo.fax}</div>
            </div>
          </div>
          <div className="contact-paragraph">
            <h2>Pour venir nous voir :</h2>
            <div className="row">
              <div className="col-3">Adresse :</div>
              <div className="col-9">
                <div>{contactInfo.address1}</div>
                <div>{contactInfo.address2}</div>
                <div>{contactInfo.zipCode} {contactInfo.city}</div>
              </div>
            </div>
          </div>
          
        </div>
        <div className="col-md-6">
          <iframe src={url} width="100%" height="100%" title="Carte google localisation centrale dia fleur" />
        </div>
      </div>
      
    </div>
  )
}

export default Contact;
